import { CompanyIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <CompanyIndexRouteView/>,
};